module.exports = __webpack_public_path__ + "img/icon_play-blk.af5dc428.svg";